import { Routes } from '@angular/router';
import { NavigationComponent } from './body/navigation/navigation.component';
import { HomeComponent } from './views/home/home.component';
import { AuthGuard } from './core/guards/auth.guard';
import { FeatureGuard } from './core/guards/feature.guard';

export const routes: Routes = [
  {
    path: '',
    component: NavigationComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [FeatureGuard],
        data: { breadcrumb: 'SIDEBAR.HOME' },
      },
      {
        path: 'management',
        canActivate: [FeatureGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./views/management/management.component').then(c => c.ManagementComponent),
            data: { breadcrumb: 'SIDEBAR.MANAGEMENT' },
          },
          {
            path: 'devices',
            canActivate: [FeatureGuard],
            children: [
              {
                path: '',
                loadComponent: () => import('./views/management/devices/devices.component').then(c => c.DevicesComponent),
                data: { breadcrumb: 'SIDEBAR.DEVICES' },
              },
              // {
              //   path: ':id',
              //   loadComponent: () => import('./views/management/device-details/device-details.component').then(c => c.DeviceDetailsComponent),
              // }
            ]
          },
        ]
      },
      {
        path: 'infrastructure',
        canActivate: [FeatureGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./views/infrastructure/infrastructure.component').then(c => c.InfrastructureComponent),
            data: { breadcrumb: 'SIDEBAR.INFRASTRUCTURE' },
          },
          {
            path: 'structural-health',
            loadComponent: () => import('./views/infrastructure/structural-health/structural-health.component').then(c => c.StructuralHealthComponent),
            data: { breadcrumb: 'SIDEBAR.STRUCTURAL_HEALTH' },
            canActivate: [FeatureGuard]
          },
          {
            path: 'traffic-monitoring',
            loadComponent: () => import('./views/infrastructure/traffic-monitoring/traffic-monitoring.component').then(c => c.TrafficMonitoringComponent),
            data: { breadcrumb: 'SIDEBAR.TRAFFIC_MONITORING' },
            canActivate: [FeatureGuard]
          }
        ]
      },
      {
        path: 'stations',
        canActivate: [FeatureGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./views/stations/stations.component').then(c => c.StationsComponent),
            data: { breadcrumb: 'SIDEBAR.STATIONS' },
          },
          {
            path: 'people',
            loadComponent: () => import('./views/stations/people-movement/people-movement.component').then(c => c.PeopleMovementComponent),
            data: { breadcrumb: 'SIDEBAR.PEOPLE' },
          }
        ]
      },
      {
        path: 'access-control',
        canActivate: [FeatureGuard],
        loadComponent: () => import('./views/access-control/access-control.component').then(c => c.AccessControlComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./views/access-control/overview/overview.component').then(c => c.OverviewComponent),
            data: { breadcrumb: 'SIDEBAR.ACCESS_CONTROL' },
          },
          {
            path: 'access-control',
            loadComponent: () => import('./views/access-control/overview/overview.component').then(c => c.OverviewComponent),
            data: { breadcrumb: { skip: true } }
          },
          {
            path: 'whitelist',
            loadComponent: () => import('./views/access-control/users-whitelist/users-whitelist.component').then(c => c.UsersWhitelistComponent),
            data: { breadcrumb: 'SIDEBAR.USERS_WHITELIST' },

          },
          {
            path: 'management',
            loadComponent: () => import('./views/access-control/access-management/access-management.component').then(c => c.AccessManagementComponent),
            data: { breadcrumb: 'SIDEBAR.ACCESS_MANAGEMENT' },
          },
        ]
      },
      {
        path: 'media-server',
        canActivate: [FeatureGuard],
        loadComponent: () => import('@wings-ict/media-server-lib').then(c => c.MediaServerLibComponent),
      },
      {
        path: 'media-server/:id', canActivate: [FeatureGuard],
        loadComponent: () => import('@wings-ict/media-server-lib').then(c => c.MediaServerLibComponent),
      },
      {
        path: 'flexi',
        canActivate: [FeatureGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./views/flexi/flexi.component').then(c => c.FlexiComponent),
            data: { breadcrumb: 'SIDEBAR.FLEXI_CROSS' },
          },
          {
            path: 'alerts',
            loadComponent: () => import('./views/flexi/incidents/incidents.component').then(c => c.IncidentsComponent),
            data: { breadcrumb: 'SIDEBAR.ALERTS' }
          }
        ]
      },
      {
        path: 'aigaleo',
        canActivate: [FeatureGuard],
        loadComponent: () => import('./views/aigaleo/aigaleo.component').then(c => c.AigaleoComponent),
        data: { breadcrumb: 'SIDEBAR.AIGALEO' },
      },
      {
        path: 'fleet',
        canActivate: [FeatureGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./views/fleet/fleet.component').then(c => c.FleetComponent),
          },
          {
            path: 'management',
            loadComponent: () => import('./views/fleet/management/management.component').then(c => c.ManagementComponent),
            data: { breadcrumb: 'Management' },
            canActivate: [FeatureGuard]
          },
          {
            path: 'alerts',
            loadComponent: () => import('./views/fleet/alerts/alerts.component').then(c => c.AlertsComponent),
            data: { breadcrumb: 'Alerts' },
            canActivate: [FeatureGuard]
          },
          {
            path: 'schedule',
            loadComponent: () => import('./views/fleet/schedule/schedule.component').then(c => c.ScheduleComponent),
            data: { breadcrumb: 'Schedule' },
            canActivate: [FeatureGuard]
          },
          {
            path: 'repairs',
            loadComponent: () => import('./views/fleet/repairs/repairs.component').then(c => c.RepairsComponent),
            data: { breadcrumb: 'Repairs' },
            canActivate: [FeatureGuard]
          },
          {
            path: 'citizen-requests',
            loadComponent: () => import('./views/fleet/citizen-requests/citizen-requests.component').then(c => c.CitizenRequestsComponent),
            data: { breadcrumb: 'Citizen Requests' },
            canActivate: [FeatureGuard]
          }
        ]
      },
      {
        path: '**',
        redirectTo: 'home',
        pathMatch: 'full'
      }
    ]
  }
];